export default [
  {
    title: '规则编号',
    key: 'ruleId'
  },
  {
    title: '类型',
    key: 'ruleType',
    overflow: true
  },
  {
    title: '游戏',
    key: 'gameNames',
    overflow: true,
    width: 242
  },
  {
    title: '规则条件',
    key: 'ruleConditionDesc',
    width: 240
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 108
  },
  {
    title: '创建人',
    key: 'opName'
  },
  {
    title: '更新人',
    key: 'upOpName'
  },
  {
    title: '操作',
    key: 'control',
    width: 110
  }
]
